module.exports = __webpack_public_path__ + "img/aisling.bfe3d394.jpg";